export default "__VITE_PUBLIC_ASSET__5a8eaf7a__"